module.exports = __webpack_public_path__ + "img/153.b0f6681e.jpg";